/* eslint-disable camelcase */
import userflow from "userflow.js";
import { USERFLOW_CONTENTS } from "@constants";

/**
 * In this service was implemented some esentials methods of userflow.js
 * for more methods if you need help, please refeere https://userflow.com/docs/userflow-js
 */

const setIdentity = user => {
	if (typeof user === "object") {
		const roleType =
			(user.IsViewOnly && "View Only") ||
			(user.IsStaffAdmin && "Administrator") ||
			(user.IsInternalCoordinator && "Coordinator") ||
			(!user.IsInternalCoordinator && !user.IsStaffAdmin && "Staff") ||
			"";

		userflow.identify(user.Id, {
			name: `${user.FirstName} ${user.LastName}`,
			email: user.Email,
			user_type_id: user.UserTypeId,
			signed_up_at: user.SignedUpAt,
			user_role: roleType,
		});

		if (user.Organization) {
			const { Organization } = user;
			userflow.group(Organization.Id, {
				name: Organization.Name,
				organization_type_id: Organization.OrganizationTypeId,
			});
		}
	}
};

const initUserFlow = user => {
	const internalFlag = localStorage.getItem("iu");
	if (!internalFlag) {
		userflow.init(USERFLOW_CONTENTS.token);
		setIdentity(user);
	}
};

const startFlow = (flowContentID, showOnce = false) => {
	userflow.start(flowContentID, { once: showOnce });
};

const resetSession = () => {
	userflow.reset();
};

export default {
	initUserFlow,
	resetSession,
	startFlow,
};
